// Import Chart.js
import { Chart, Tooltip } from 'chart.js';
// Import Tailwind config
import { tailwindConfig, hexToRGB } from '../utils/Utils';

Chart.register(Tooltip);

// Define Chart.js default settings
Chart.defaults.font.family = '"Inter", sans-serif';
Chart.defaults.font.weight = '500';
Chart.defaults.plugins.tooltip.borderWidth = 1;
Chart.defaults.plugins.tooltip.displayColors = false;
Chart.defaults.plugins.tooltip.mode = 'nearest';
Chart.defaults.plugins.tooltip.intersect = false;
Chart.defaults.plugins.tooltip.position = 'nearest';
Chart.defaults.plugins.tooltip.caretSize = 0;
Chart.defaults.plugins.tooltip.caretPadding = 20;
Chart.defaults.plugins.tooltip.cornerRadius = 4;
Chart.defaults.plugins.tooltip.padding = 8;

// Register Chart.js plugin to add a bg option for chart area
Chart.register({
    id: 'chartAreaPlugin',

    beforeDraw: (chart) => {
        if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
            const ctx = chart.canvas.getContext('2d');
            const { chartArea } = chart;
            ctx.save();
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;

            ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
            ctx.restore();
        }
    },
});

export const chartColors = {
    textColor: {
        light: '#9CA3AF',
        dark: '#6B7280'
    },
    gridColor: {
        light: '#F3F4F6',
        dark: `rgba(${hexToRGB('#374151')}, 0.6)`
    },
    backdropColor: {
        light: tailwindConfig().theme.colors.white,
        dark: tailwindConfig().theme.colors.slate[800],
    },
    tooltipTitleColor: {
        light: tailwindConfig().theme.colors.slate[800],
        dark: tailwindConfig().theme.colors.slate[100],
    },
    tooltipBodyColor: {
        light: '#6B7280',
        dark: '#9CA3AF'
    },
    tooltipBgColor: {
        light: '#ffffff',
        dark: '#374151'
    },
    tooltipBorderColor: {
        light: '#E5E7EB',
        dark: '#4B5563'
    },
    chartAreaBg: {
        light: tailwindConfig().theme.colors.slate[50],
        dark: `rgba(${hexToRGB(tailwindConfig().theme.colors.slate[900])}, 0.24)`,
    },
};

export function getHtmlLegendPlugin(legendRef) {
    return {
        id: 'htmlLegend',
        afterUpdate(chart, args, options) {
            const container = legendRef.current;
            if (!container) return;

            while (container.firstChild) {
                container.firstChild.remove();
            }

            const ul = document.createElement('ul');
            ul.className = 'list-none flex flex-wrap justify-center gap-x-2 gap-y-1 py-3 pr-4';
            container.appendChild(ul);

            const items = chart.options.plugins.legend.labels.generateLabels(chart);
            items.forEach(item => {
                if (item.text !== undefined) {
                    const li = document.createElement('li');

                    const button = document.createElement('button');
                    button.className = 'btn-xs bg-white text-xs dark:bg-gray-700 text-gray-500 dark:text-gray-400 rounded-full ' +
                        'border-gray-200 hover:border-gray-400 dark:border-gray-600 dark:hover:border-gray-400';
                    button.onclick = () => {
                        chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
                        chart.update();
                        button.style.opacity = chart.isDatasetVisible(item.datasetIndex) ? '1' : '.3';
                    };

                    const box = document.createElement('span');
                    box.style.display = 'block';
                    box.style.width = '8px';
                    box.style.height = '8px';
                    box.style.backgroundColor = item.fillStyle;
                    box.style.borderRadius = '100%';
                    box.style.marginRight = '4px';
                    box.style.pointerEvents = 'none';

                    const label = document.createElement('span');
                    label.style.display = 'flex';
                    label.style.alignItems = 'center';
                    const labelText = document.createTextNode(item.text);
                    label.appendChild(labelText);

                    button.appendChild(box);
                    button.appendChild(label);
                    li.appendChild(button);
                    ul.appendChild(li);

                    button.style.opacity = chart.isDatasetVisible(item.datasetIndex) ? '1' : '.3';
                }
            });
        }
    };
}
